<template>
  <div>
    <div
      :class="[
        { 'col-md-4': vertical && !tabNavWrapperClasses },
        { 'col-12': centered && !tabNavWrapperClasses },
        tabNavWrapperClasses
      ]"
    >
      <ul
        class="nav nav-pills"
        role="tablist"
        :class="[
          `nav-pills-${type}`,
          { 'nav-pills-icons': square },
          { 'flex-column': vertical },
          { 'justify-content-center': centered },
          tabNavClasses
        ]"
      >
        <li
          v-for="(tab,t_index) in tabs"
          class="nav-item"
          data-toggle="tab"
          role="tablist"
          aria-expanded="true"
          :key="tab.id"
          
        >
          <a
            data-toggle="tab"
            role="tablist"
            :href="`#${tab.id}`"
            @click.prevent="activateTab(tab)"
            :aria-expanded="tab.active"
            class="nav-link"
            :class="[{ 'active': (tab.active) },{'inoneline':inline},pillsClass[t_index],{ 'disabled': tab.disabled }]"
          >
            <tab-item-content :tab="tab"> </tab-item-content>
            
          </a>
        </li>
      </ul>
    </div>
    <div
      class="tab-content"
      :class="[
        { 'tab-space': !vertical },
        { 'col-md-8': vertical && !tabContentClasses },
        tabContentClasses
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import {eventEmitter} from "src/plugins/globalComponents.js";
export default {
  name: 'tabs',
  components: {
    TabItemContent: {
      props: ['tab'],
      render(h) {
        return h('div', [this.tab.$slots.label || this.tab.label]);
      }
    }
  },
  provide() {
    return {
      addTab: this.addTab,
      removeTab: this.removeTab
    };
  },
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: value => {
        let acceptedValues = [
          'primary',
          'info',
          'success',
          'warning',
          'danger',
          'simple'
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeTab: {
      type: String,
      default: ''
    },
    tabNavWrapperClasses: {
      type: [String, Object],
      default: ''
    },
    tabNavClasses: {
      type: [String, Object],
      default: ''
    },
    tabContentClasses: {
      type: [String, Object],
      default: ''
    },
    vertical: Boolean,
    square: Boolean,
    centered: Boolean,
    inline: Boolean,
    value: String,
    // tabs: Array,
    pillsClass: {
      type: Array,
      default: function(){return ['','','','','','','','','','','','','','','','','','','','','','','','','','','',];}
    },
  },
  data() {
    return {
      tabs: []
    };
  },
  methods: {
    findAndActivateTab(label) {
      let tabToActivate = this.tabs.find(t => t.label === label);
      if(typeof tabToActivate == 'undefined'){
        tabToActivate = this.tabs.find(t => t.id === label);
      }
      if (tabToActivate) {
        this.activateTab(tabToActivate);
      }
      
    },
    activateTab(tab) {
      if (this.handleClick) {
        this.handleClick(tab);
      }
      this.deactivateTabs();
      tab.active = true;      
      //this.$emit('input', tab.id);
      this.$emit('change', tab.id);
    },
    deactivateTabs() {
      this.tabs.forEach(tab => {
        tab.active = false;
      });
    },
    addTab(tab) {
      const index = this.$slots.default.indexOf(tab.$vnode);
      if (!this.activeTab && index === 0) {
        tab.active = true;
      }

      if (this.activeTab === tab.id /*tab.name*/) {
        tab.active = true;
      }
      if (this.activeTab != tab.id /*tab.name*/) {
        tab.active = false;
      }
      this.tabs.splice(index, 0, tab);
      // console.log(tab.name);
    },
    removeTab(tab) {
      const tabs = this.tabs;
      const index = tabs.indexOf(tab);
      if (index > -1) {
        tabs.splice(index, 1);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.findAndActivateTab(this.value);
      }else if(this.activeTab){
        let tabToActivate = this.tabs.find(t => t.id === this.activeTab);
        if (tabToActivate) {
          this.activateTab(tabToActivate);
        }
      }

    });
  },
  watch: {
    value(newVal) {
      // console.log('value tabs watch', newVal);
      
      // for(let i = 0; i < this.tabs.length; i++){
      //   if(this.tabs[i].label == newVal){
      //     console.log('this.tabs[i].name ', this.tabs[i]);
      //   } else { console.log('this.tabs[i].name ', this.tabs[i].label)}
      // }
      /* в ленте задача this.tabs не перерисовываются, сохраняются от старых задач*/

      this.$emit('tabschanged');
      this.findAndActivateTab(newVal);
    },
   
  }
};
</script>

<style>
.inoneline .tab-label{
  display: inline-flex;
  align-items: center;
  height: 40px;
}
.inoneline .tab-label .tab-icon{margin-right: 10px;}

.white-content .nav-pills.nav-pills-simple .nav-item .nav-link:not(.active){background: transparent;}
.nav-pills.nav-pills-simple .nav-item .nav-link{
  background: transparent;
  border: 1px solid grey;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.active{}
.nav-pills.nav-pills-simple .nav-item .nav-link.success{
  color: #00BF9A;
  border-color: #00BF9A;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.active.success{
  color: #fff;
  background: #00BF9A;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.danger{
  color: #F84E54;
  border-color: #F84E54;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.active.danger{
  color: #fff;
  background: #F84E54;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.warning{
    color: #ff8d72;
    border-color: #ff8d72;
}
.nav-pills.nav-pills-simple .nav-item .nav-link.active.warning{
  color: #fff;
  background: #ff8d72;
}

</style>
